import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import classNames from 'lib/classNames';
// import styles from 'styles/icon.module.scss';

const Icon = props => {
    const {
        icon,
        size,
        style,
        className,
        type,
        onClick,
        spin,
        color,
        iconRef,
        onMouseEnter,
        onMouseLeave
    } = props;
    if (!icon) console.log(props);
    return (
        <FontAwesomeIcon
            icon={icon}
            size={size}
            color={color}
            className={classNames(className, { 'cursor-pointer': onClick })}
            spin={spin}
            onMouseEnter={e => {
                if (onMouseEnter) onMouseEnter(e);
            }}
            onMouseLeave={e => {
                if (onMouseLeave) onMouseLeave(e);
            }}
            ref={iconRef}
            onClick={onClick}
            style={style}
        />
    );
};

Icon.propTypes = {
    style: PropTypes.object.isRequired
};

Icon.defaultProps = {
    style: {},
    size: '1x',
    className: '',
    type: 'normal',
    onClick: null,
    spin: false,
    color: null,
    iconRef: null,
    onMouseEnter: null,
    onMouseLeave: null
};

export default Icon;
